import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { INormalText, EEntityType, TextRelationType } from '@web/dtos';

@Pipe({
  name: 'filterTexts',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class FilterTextsPipe implements PipeTransform {
  transform(
    texts: INormalText[] | undefined,
    fieldName: TextRelationType,
    entity?: EEntityType
  ): INormalText[] {
    return (
      texts
        ?.filter((text: INormalText) => fieldName === text.relationType)
        ?.filter((text: INormalText) =>
          entity ? entity === text.entityType : true
        ) ?? []
    );
  }
}
